import { createContext, useContext } from 'react';
import { emptyAsyncFunc } from '@shared/react';
import { BooleanPermissions, BooleanFeatures } from './interfaces';
import { Authorization_AccessTokenPayload, EAuthorization_Features, User } from '@shared/api';

export interface IOpenIdContext {
    logout: (callbackPath?: string | null | undefined, extras?: any) => Promise<void>;
    user: User | null;
    features: BooleanFeatures | null;
    permissions: BooleanPermissions | null;
    token: Authorization_AccessTokenPayload | null;
    roles: EAuthorization_Features[] | null;
}

export const OpenIdContext = createContext<IOpenIdContext>({
    logout: emptyAsyncFunc,
    user: null,
    features: null,
    permissions: null,
    token: null,
    roles: null,
});

export const useOpenIdContext = () => {
    const context = useContext(OpenIdContext);
    if (!context) {
        throw new Error('useOpenIdContext must be used within an OpenIdProvider');
    }
    return context;
};
